// Removes specific characters from string
export const sanitizeValue = (string) => {
    return string
        .replace(/</g, '') // <
        .replace(/script>/g, '') // script>
        .replace(/(\\|\/)/, ''); // / or \
};
// Remove email address from string
export const removeEmail = (string) => {
    return string.replace(/([^.@\s]+)(\.[^.@\s]+)*@([^.@\s]+\.)+([^.@\s]+)/, '*epost*');
};
